import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import cookie from 'react-cookies';
import Link from 'next/link';
import { captureException } from '@sentry/node';
import { dataLayerPush } from '@ertelecom/ui-react/components/helpers';
import GridContainer from '@ertelecom/ui-react/components/layouts/gridContainer';
import PopupResult from '@ertelecom/ui-react/components/popups/popupResult';
import Scrolling from '@ertelecom/ui-react/components/navigation/scrolling';
import InterestingBlock from '@ertelecom/ui-react/components/blocks/interestingBlocks';
import { getUserTvInfo } from '~/src/api/equipment';
import {
    sendRequestByConnection,
    parseRequestByConnection,
    dataLayerForCBPhonePushWrapper,
} from '~/src/api/service-request/request-by-connection';
import { ClientTv } from '~/src/components/Equipment/tv/clientTv';
import { OrderPopup } from '~/src/components/Equipment/tv/orderPopup';
import { CallBackForm } from '~/src/components/Equipment/form/callBackForm';
import { SmartTv } from '~/src/components/Equipment/tv/smartTv';
import { Note } from '~/src/components/Equipment/tv/note';
import { data } from '~/src/components/DomRuTv/data';
import QuizBlock from '~/src/components/QuizBlock';
import Banner from '~/src/components/Banners/Banner';
import { getClientId } from '~/src/helpers/clientInfo';
import * as ST from './domruTvStyled';
import { Info } from '~/src/components/DomRuTv/Info';
import { InfoContainer } from '~/src/components/Equipment/internet/styled';
import DevicesGrid from '~/src/components/Equipment/internet/devicesGrid';
import Router from 'next/router';
import { EVENTS } from '~/src/constants/analytics';

export const tabsArray = [
    {
        id: 'main',
        title: 'На обычном телевизоре',
        link: '/domru-tv/equipment/',
        gaAction: 'btn click on standard TV',
    },
    {
        id: 'smart',
        title: 'На Smart-телевизоре',
        link: '/domru-tv/equipment/smart',
        gaAction: 'btn click on smart tv',
    },
    {
        id: 'note',
        title: 'На ноутбуке или смартфоне',
        link: '/domru-tv/equipment/note',
        gaAction: 'btn click on laptop or smartphone',
    },
];

const PRODUCT_ID_TV = 53;

class EquipmentDomruTv extends Component {
    static defaultProps = {
        pageAlias: 'main',
        productList: [],
        banners: [],
        questions: [],
    };

    static propTypes = {
        isAuth: PropTypes.bool,
        currentCity: PropTypes.object,
        pageAlias: PropTypes.string,
        productList: PropTypes.array,
        token: PropTypes.string,
        banners: PropTypes.array,
        questions: PropTypes.array,
    };

    constructor(props) {
        super(props);
        this.state = {
            clientTv: null,
            isOrderInit: false,
            resultTitle: null,
            resultText: null,
            resultType: 'success',
            isResult: false,
            selectRouter: null,
            isLoadingForm: false,
            isLoadingPopupForm: false,
        };

        this.popupRequest = React.createRef();
    }

    componentDidMount() {
        const { isAuth } = this.props;

        if (process.browser && isAuth) {
            this.getUserTv();
        }
    }

    componentDidUpdate(prevProps) {
        const { isAuth, currentCity } = this.props;
        if (!prevProps.isAuth && isAuth || isAuth && prevProps.currentCity.domain !== currentCity.domain) {
            this.getUserTv();
        }
    }

    getUserTv = () => {
        const { currentCity, token } = this.props;
        getUserTvInfo(currentCity.billingHost, token).then(clientTv => {
            if (clientTv && clientTv.length > 0) {
                this.setState({ clientTv });
            }
        });
    };

    openPopupResult = (ok, message, result) => {
        this.setState({
            isResult: true,
            resultType: result,
            resultTitle: ok ? 'Заявка на подключение отправлена' : 'Не удалось отправить заявку',
            resultText: ok ? 'Мы свяжемся с вами в ближайшее время' : message,
            isOrderInit: false,
            isLoadingForm: false,
            isLoadingPopupForm: false,
        });
    };

    createOrder = (params) => {
        const { currentCity } = this.props;
        const { selectRouter } = this.state;
        const clientId = cookie.load('_ga_cid');

        params.product_id = PRODUCT_ID_TV;
        params.city_id = currentCity.cityId;
        params.ga_cid = clientId ? clientId : getClientId();

        if (selectRouter) {
            const { global_id } = selectRouter.equip;
            const { value, type } = selectRouter.option;
            const isLeasing = type !== 1;

            params.tv_equipment_id = global_id;
            params.tv_equipment_buy = isLeasing ? 'leasing' : 'sale';
            if (isLeasing) {
                params.tv_equipment_duration = value;
            }
        }

        sendRequestByConnection(currentCity.domain, params)
            .then(res => {
                const { message, ok, status } = parseRequestByConnection(res);
                const { selectRouter } = this.state;
                const option = `${selectRouter.equip.alias} | ${selectRouter.option.label}`;
                dataLayerForCBPhonePushWrapper({ ...res, option, isPopup: true });
                this.openPopupResult(ok, message, status);
            })
            .catch(err => {
                captureException(err);
                this.openPopupResult(false, '', 'error');
            });
    };

    sendRequest = (params) => {
        this.setState({ isLoadingForm: true });
        this.createOrder(params);
    };

    sendPopupRequest = (params) => {
        this.setState({ isLoadingPopupForm: true });
        this.createOrder(params);
    };

    initOrder = (equip, option) => {
        const { isAuth } = this.props;

        if (isAuth) {
            const { global_id: ensId } = equip;
            const { value: leasing } = option;
            const productId = PRODUCT_ID_TV;

            dataLayerPush({
                event: EVENTS.UAevent,
                category: 'full-buy-equip',
                action: 'clicked_to_order',
                label: '/full_buy_tv_box',
            });

            Router.push(`/full-buy-equip?ensId=${ensId}&productId=${productId}&leasing=${leasing}`);

            return;
        }

        this.setState({
            selectRouter: {
                equip,
                option,
            },
            isOrderInit: true,
        });
    };

    closeOpderPopup = () => {
        this.setState({ isOrderInit: false });
    };

    closeResult = () => {
        this.setState({
            requestTitle: null,
            requestText: null,
            isResult: false,
        });
    };

    renderNavBar() {
        const { clientTv } = this.state;
        const { pageAlias } = this.props;

        return (
            <ST.NavContainer>
                <GridContainer>
                    <ST.RouterListTitle>Выберите, как {clientTv ? 'еще' : ''} смотреть ТВ</ST.RouterListTitle>
                    <ST.ButtonNavContainer>
                        <Scrolling>
                            {tabsArray.map(item =>
                                <Link key={item.id}
                                      href={item.id === 'main' ? '/domru-tv/equipment/' : '/domru-tv/equipment/[alias]'}
                                      as={item.link} scroll={false} passHref>
                                    <ST.ButtonNav active={pageAlias === item.id}>
                                        {item.title}
                                    </ST.ButtonNav>
                                </Link>)}
                        </Scrolling>
                    </ST.ButtonNavContainer>
                </GridContainer>
            </ST.NavContainer>
        );
    }

    renderPageContent() {
        const { pageAlias, currentCity, productList, token, banners } = this.props;

        const banner = !!banners.length && banners[0].bannerInfo;

        switch (pageAlias) {
            case 'main':
                return (
                    <ST.Wrapper>
                        <ST.RouterListContainer>
                            <ST.MainContainer>
                                <ST.RouterPageTitle>Приставки для цифрового ТВ</ST.RouterPageTitle>

                                <DevicesGrid
                                    data-test='list-tv'
                                    createOrder={this.initOrder}
                                    devices={productList}
                                    currentCity={currentCity}
                                    baseRoute={'/domru-tv/equipment'}
                                />
                            </ST.MainContainer>
                        </ST.RouterListContainer>

                        <ST.TestDriveContainer>
                            {
                                banner &&
                                <Banner
                                    marginTop='0'
                                    marginBottom='20px'
                                    onClickHandler={() => window.location.href = banner.link}
                                    banner={banner}
                                />
                            }
                            <CallBackForm
                                title='Трудно выбрать? Мы поможем.'
                                desc='Если не знаете, какое оборудование подобрать — оставьте заявку. Мы перезвоним.'
                                sendRequest={this.sendRequest}
                                isLoading={this.state.isLoadingForm}
                            />
                        </ST.TestDriveContainer>
                    </ST.Wrapper>
                );
            case 'smart':
                return <Fragment>
                    <ST.SmartContainer>
                        <SmartTv/>
                    </ST.SmartContainer>
                    <ST.TestDriveContainerWhite id='CallBackForm'>
                        <ST.TestDriveContainer>
                            <CallBackForm
                                title='Оставьте заявку на подключение ТВ на Smart TV'
                                desc='Менеджер перезвонит в ближайшее время и объяснит все детали.'
                                sendRequest={this.sendRequest}
                                isLoading={this.state.isLoadingForm}
                            />
                        </ST.TestDriveContainer>
                    </ST.TestDriveContainerWhite>
                </Fragment>;
            case 'note':
                return <Fragment>
                    <ST.SmartContainer>
                        <Note token={token} city={currentCity.billingDomain}/>
                    </ST.SmartContainer>
                </Fragment>;
        }
    }

    render() {
        const { clientTv, isOrderInit, resultTitle, resultText, resultType, isResult, selectRouter } = this.state;
        const { currentCity, questions } = this.props;

        return (
            <Fragment>
                {clientTv &&
                <ST.MainContainer>
                    <ClientTv clientTv={clientTv}/>
                </ST.MainContainer>
                }
                {this.renderNavBar()}
                {this.renderPageContent()}
                {
                    !!questions.length &&
                    <ST.QuizSection>
                        <GridContainer>
                            <QuizBlock/>
                        </GridContainer>
                    </ST.QuizSection>
                }
                <GridContainer>
                    <InterestingBlock
                        list={data}
                        blocksTitle='Вам может быть интересно'
                    />
                </GridContainer>

                <GridContainer>
                    <InfoContainer>
                        <Info city={currentCity}/>
                    </InfoContainer>
                </GridContainer>

                <OrderPopup
                    isOpened={isOrderInit}
                    closeClick={this.closeOpderPopup}
                    sendRequest={this.sendPopupRequest}
                    selectEquip={selectRouter}
                    isLoading={this.state.isLoadingPopupForm}
                    isPopup={true}
                />

                <PopupResult
                    isOpen={isResult}
                    onClose={this.closeResult}
                    title={resultTitle}
                    text={resultText}
                    type={resultType}
                />
            </Fragment>
        );
    }
}

const mapStateToProps = (state) => ({
    isAuth: state.auth.isAuth,
    token: state.auth.accessToken,
    currentCity: state.city.currentCity,
    questions: state.quiz.questions,
});

export default connect(
    mapStateToProps,
)(EquipmentDomruTv);
